//@flow
export const INTERPOLATION_SETTING_VARS = {
  CRM_CONTACT_NAME: {
    key: 'nombre_contacto',
    label: 'Nombre del contacto',
    name: 'CRM_CONTACT_NAME',
    templateKey: '1',
  },
};

export const CAMPAIGN_EXECUTION_STATE_LABELS = {
  SCHEDULED: 'Programado',
  COMPLETED: 'Completado',
  FAILED: 'Fallido',
  CANCELED: 'Cancelado',
  EXECUTING: 'Ejecutando',
};

export const CAMPAIGN_EXECUTION_STATE_COLORS = {
  SCHEDULED: 'info',
  COMPLETED: 'success',
  FAILED: 'danger',
  CANCELED: 'warning',
  EXECUTING: 'primary',
};
